module.exports = __webpack_public_path__ + "static/media/added-value.a88e362a.svg";